import { Component, OnInit, ViewChild, Output, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FileUploadModule, FileUpload, MenuItem, SelectItem } from 'primeng/primeng';
import { VALID } from '@angular/forms/src/model';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { RequestOptions } from '../../../node_modules/@angular/http';
import { Observable } from "rxjs/Observable";
import { UserService } from '../shared/user.service';
import { AppSettings } from '../shared/AppSettings';
import { Form161Service } from '../service/form161.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MsvfileService } from '../service/msvfile.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'feedback-upload',
  templateUrl: './feedback-upload.component.html',
  styleUrls: ['./feedback-upload.component.css']
})
export class FeedbackUploadComponent implements OnInit {
  @ViewChild('fileInput') fileInput: FileUpload;
  list: any = [];
  //resultTable: FileLoadDataCompletitions[] = null;
  errors: any[] = null;
  warnings: any[] = null;
  fileId: number = null;
  dataCompletitionsErrors: any[] = null;
  //result: FileLoadDataResult = null;
  msgs: any[] = [];

  resultTable: any[] = null;
  result: any = null;
  //afterResultTable: any[] = null;
  //afterResult: any = null;
  resultToUser: boolean = false;
  message: boolean = false;
  overrideIfFileExist: boolean = false;
  public userDetails: any;
  fileList: FileList = null;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  cols: any[];
  //visible: boolean = false;
  readonly rootUrl = AppSettings.webApiURL;
  tableCustomerDetail: any = { AccountNameBank: null, BankBranchName: null, BankName: '', BankNumber: '', CustomerName: '', IdentityNumber: '' }
  listBank: any[] = [];
  listBankKolet: any[] = [];


  items: MenuItem[];
  activeIndex: number = 0;
  actionList: SelectItem[];
  actionId: number = null; //selectedActionId

  display: boolean = false;
  fileName: string = '';
  //messages: number = 2;
  listMsv: any[] = [];
  selectedMsvId: number = null;
  paramId: number = null;
  today: Date = new Date();
  alertMessage: string = '';

  constructor(private userService: UserService, private form161Service: Form161Service, public httpClient: HttpClient, private msvService: MsvfileService, private router: ActivatedRoute) { }

  ngOnInit() {
    
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'תקלה בקבלת פרטי משתמש');
      });

    
  }


  fileChange(event) {
    this.fileList = event.target.files;
  }

  fileUpload() {
   
    if (this.fileList && this.fileList.length > 0) {
      let file: File = this.fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);

      var reqHeader = new HttpHeaders(
        {
          //'Content-Type': 'multipart/form-data',
          'Accept': 'application/json'
        });
      this.httpClient.post(`${this.rootUrl}/api/FeedbackUpload/Upload`, formData, { headers: reqHeader })
        .subscribe((response: any) => {
          this.message = false;
          this.result = response;
          
          if (this.result == '') {
            this.showMessage('success', '', 'הקובץ הועלה לשרת ויטופל בהמשך ע"י תהליך הטעינה. בסיום הטעינה ישלח מייל למנהל המערכת');
          }
          else
          {
            this.showMessage('error', '', this.result);
          }


        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהעלאה או פתיחת קובץ zip');
          this.activeIndex = 0;
          this.alertMessage = '';
        });
    }
    else {
      this.showMessage('error', '', 'יש לבחור קובץ');
      this.activeIndex = 0;
      this.alertMessage = '';
      //this.messages = null;
    }
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });   //type='success'/'error'/'warn'/'success'
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-upload/feedback-upload.component.ts